import { Field, ID, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { IAction } from '../../action/IAction'
import type { Logistic } from '../Logistic'

@InputType()
export class SetLogisticCustomShippingCarrierArgs extends ActionArgs {
  @Field(() => ID)
  logisticId: string

  @Field(() => String)
  carrier: string

  @Field(() => String)
  serviceCode: string
}

export interface ISetLogisticCustomShippingCarrier extends IAction<Logistic, SetLogisticCustomShippingCarrierArgs> {}
